import { getWorkspaceIdFromCurrentUrl } from '@/utils/workspace-id';

/**
 * Sets the params for the request, including the account ID and workspace ID.
 */
export function contextualParams<T extends Record<string, unknown>>(
  // oxlint-disable-next-line typescript/consistent-type-assertions -- pre-existing assertion; replace with narrowing when touched
  params: T = {} as T,
) {
  const accountId = window.__hydra__?.account?.id;
  const workspaceId = getWorkspaceIdFromCurrentUrl();

  return {
    accountId,
    workspaceId,
    ...params,
  };
}
